export const EDIT_ENTITY_MAX_COUNT = 10;
export const EDIT_ENTITY_ADMIN_MAX_COUNT = 100;
